import Vue from "vue";
import Vuex from "vuex";
import payment from "./modules/payment";
import campaign from "./modules/campaign.js";
import automation from "./modules/automation.js";
import advancedAutomation from "./modules/advancedAutomation.js";
import automationReport from "./modules/automationReport.js";
import advancedAutomationReport from "./modules/advancedAutomationReport.js";
import common from "./modules/common.js";
import autoresponder from "./modules/autoresponder";
import segment from "./modules/segment";
import recipients from "./modules/recipients";
import report from "./modules/report";
import autoReport from "./modules/autoReport";
import contact from "./modules/contact.js";
import gallery from "./modules/gallery.js";
import gallerylist from "./modules/gallerylist.js";
import user from "./modules/user.js";
import sender from "./modules/sender.js";
import replyid from "./modules/replyid.js";
import domain from "./modules/domain.js";
import api from "./modules/api.js";
import profile from "./modules/profile.js";
import dashboard from "./modules/dashboard.js";
import mctemplates from "./modules/mctemplates";
import tags from "./modules/tags.js";
import logs from "./modules/logs.js";
import summary from "./modules/contactSummary.js";
import formBuilder from "./modules/formBuilder.js";
import form from "./modules/form.js";
import dragger from "./modules/dragger.js";
import chatbot from "./modules/chatbot.js";

Vue.use(Vuex);

const debug = process.env.VUE_APP_NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    payment,
    campaign,
    automation,
    automationReport,
    advancedAutomationReport,
    common,
    autoresponder,
    segment,
    recipients,
    report,
    autoReport,
    contact,
    gallery,
    gallerylist,
    user,
    sender,
    replyid,
    domain,
    api,
    profile,
    dashboard,
    mctemplates,
    tags,
    logs,
    summary,
    formBuilder,
    form,
    dragger,
    chatbot,
    advancedAutomation,
  },
  strict: debug,
});
